// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"185":"4e3ad8ccc145da3aa8ea","491":"4e3ad8ccc145da3aa8ea","580":"4e3ad8ccc145da3aa8ea"}[chunkId] + ".css";
};